"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SourcesController", {
    enumerable: true,
    get: function() {
        return SourcesController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _sourcesservice = require("~/services/sources.service");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _responseHelpers = require("~/helpers/responseHelpers");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let SourcesController = class SourcesController {
    async baseGet(context, sourceId) {
        const source = await this.sourcesService.baseGetWithConfig(context, {
            sourceId
        });
        if (source.isMeta()) {
            source.config = undefined;
        }
        source.integration_config = undefined;
        (0, _responseHelpers.maskKnexConfig)(source);
        return source;
    }
    async baseUpdate(context, sourceId, baseId, body, req) {
        const source = await this.sourcesService.baseUpdate(context, {
            sourceId,
            source: body,
            baseId,
            req
        });
        source.config = undefined;
        source.integration_config = undefined;
        return source;
    }
    async baseList(context, baseId) {
        const sources = await this.sourcesService.baseList(context, {
            baseId
        });
        for (const source of sources){
            source.config = undefined;
            source.integration_config = undefined;
        }
        return new _PagedResponse.PagedResponseImpl(sources, {
            count: sources.length,
            limit: sources.length
        });
    }
    constructor(sourcesService){
        this.sourcesService = sourcesService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/bases/:sourceId',
        '/api/v2/meta/bases/:baseId/sources/:sourceId'
    ]),
    (0, _extractidsmiddleware.Acl)('baseGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('sourceId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SourcesController.prototype, "baseGet", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/projects/:baseId/bases/:sourceId',
        '/api/v2/meta/bases/:baseId/sources/:sourceId'
    ]),
    (0, _extractidsmiddleware.Acl)('baseUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('sourceId')),
    _ts_param(2, (0, _common.Param)('baseId')),
    _ts_param(3, (0, _common.Body)()),
    _ts_param(4, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _nocodbsdk.BaseReqType === "undefined" ? Object : _nocodbsdk.BaseReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SourcesController.prototype, "baseUpdate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/bases',
        '/api/v2/meta/bases/:baseId/sources'
    ]),
    (0, _extractidsmiddleware.Acl)('baseList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SourcesController.prototype, "baseList", null);
SourcesController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _sourcesservice.SourcesService === "undefined" ? Object : _sourcesservice.SourcesService
    ])
], SourcesController);
